/**
 * Canonical API endpoint paths, grouped by upstream service.
 * Ported 1:1 from the mobile app's `backend_api_client.dart` /
 * `auth_api_client.dart` so the contract stays identical.
 */
export const endpoints = {
  /** Backend website service (Laravel 10) — `VITE_BACKEND_BASE_URL`. */
  backend: {
    login: '/login-password',
    refresh: '/refresh',
    logout: '/logout',
    requestPasswordReset: '/password-reset/request',
    resetPasswordWithOtp: '/password-reset/reset-with-otp',
    exchangeGoogleToken: '/exchange-google-token',
    exchangeFacebookToken: '/exchange-facebook-token',
    exchangeAppleToken: '/exchange-apple-token',
    /** Public maintenance status for Contul meu (scheduled from the admin portal). */
    maintenance: '/maintenance/client-area',
  },
  /** Auth/OAuth server (Laravel 11 + Passport) — `VITE_AUTH_BASE_URL`. */
  auth: {
    me: '/v1/me',
    // Account creation + post-login email verification go straight to the auth
    // server, same contract as the mobile app. register is public; verify and
    // resend need the session's Bearer (they verify the signed-in account).
    register: '/v1/register',
    verifyOtp: '/v1/verify-otp',
    resendOtp: '/v1/resend',
    endpointUrls: '/v2/endpoint-urls', // v2: ?is_mobile=0|1 + api_version per row (v1 route stays for prod mobile builds)
    /** EasyAuth (X-ZUMO-AUTH) token for ONE MEDIS host, on demand — body `{ host }`, Bearer. */
    zumoToken: '/v1/zumo-token',
    checkAttachEligibility: '/check-attach-eligibility',
    attachSocialAccount: '/attach-social-account',
    detachSocialAccount: '/detach-social-account',
    attachStart: '/attach/start',
  },
  /** MEDIS real-time service (Azure) — `VITE_MEDIS_BASE_URL`. */
  medis: {
    newSession: '/NewSession',
    getPatient: '/GetPatient',
    getAppointments: '/GetAppointments',
    getAccessList: '/GetAccessList',
    getDocument: '/GetDocument',
    registerPatient: '/RegisterPatient',
    timetable: '/Timetable',
    setAppointment: '/SetAppointment',
  },
} as const;
